"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../schema");
const praCdc = schema_1.Schema.number()
    .expiration(15552000)
    .unit("%")
    .integer()
    .min(0)
    .max(100)
    .interpretation({ vocab: "htx", code: "pra_cdc" })
    .tag({ vocab: "loinc", code: "80737-0" });
const praLuminex = schema_1.Schema.number()
    .optional()
    .expiration(15552000)
    .unit("%")
    .integer()
    .min(0)
    .max(100)
    .interpretation({ vocab: "htx", code: "pra_luminex" })
    .tag({ vocab: "loinc", code: "80737-0" });
const transplantImmunConcilium = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "htx", code: "transplant_immun_concilium" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ praCdc, praLuminex, transplantImmunConcilium });
